import script from "./ScrollArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScrollArea.vue?vue&type=script&lang=ts&setup=true"

import "./ScrollArea.vue?vue&type=style&index=0&id=339a4f6a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339a4f6a"]])

export default __exports__